module.exports = __webpack_public_path__ + "static/media/team2.4c4d6f7f.jpg";